import PropTypes from "prop-types";
import {css} from "@emotion/react";

const CopyWidget = ({content}) => {

    const {copy} = content;

    const copyWidgetStyles = css(`
        text-align: center;
        width: 100%;
    `);

    const copyDom = copy.map(str => {
        return <p css={copyWidgetStyles} key={str} dangerouslySetInnerHTML={{__html: str}}></p>
    })

    return <div>
        {copyDom}
    </div>;
};

CopyWidget.propTypes = {
    content: PropTypes.object,
};

export default CopyWidget;
